class StrayzyStickyHeader extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section');
    if (!section || this.dataset.sticky === 'false') return;

    if (this.dataset.stickyBehavior === 'always') {
      this.classList.add('is-scrolled');
      return;
    }

    this.sentinel = document.createElement('span');
    this.sentinel.className = 'strayzy-header-sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');
    document.body.prepend(this.sentinel);

    this.observer = new IntersectionObserver(([entry]) => {
      this.classList.toggle('is-scrolled', !entry.isIntersecting);
    });
    this.observer.observe(this.sentinel);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.sentinel?.remove();
  }
}

class StrayzyMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.openButton = this.querySelector('[data-strayzy-drawer-open]');
    this.closeButton = this.querySelector('[data-strayzy-drawer-close]');
    if (!this.dialog || !this.openButton || !this.closeButton) return;

    this.openButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.dialog.addEventListener('close', () => this.unlockPage());
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('keydown', (event) => this.trapFocus(event));
  }

  open() {
    this.scrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
    this.dialog.showModal();
    this.closeButton.focus();
  }

  close() {
    if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.dialog.close();
      return;
    }

    this.dialog.classList.add('is-closing');
    const panel = this.dialog.querySelector('.strayzy-menu-drawer__panel');
    let hasClosed = false;
    const finishClose = () => {
      if (hasClosed) return;
      hasClosed = true;
      window.clearTimeout(this.closeTimer);
      this.dialog.classList.remove('is-closing');
      this.dialog.close();
    };

    panel?.addEventListener('animationend', finishClose, { once: true });
    this.closeTimer = window.setTimeout(finishClose, 220);
  }

  unlockPage() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, this.scrollPosition || 0);
    this.openButton.focus();
  }

  trapFocus(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = [...this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), summary, select, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.getClientRects().length);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

if (!customElements.get('strayzy-sticky-header')) {
  customElements.define('strayzy-sticky-header', StrayzyStickyHeader);
}
if (!customElements.get('strayzy-menu-drawer')) {
  customElements.define('strayzy-menu-drawer', StrayzyMenuDrawer);
}
